import formatName from 'I18n/utils/formatName';
import apiClient from 'hub-http/clients/apiClient';
import { hasTeamHierarchies } from 'sales-content-partitioning/lib/Permissions';
import { createRpcClientV2 } from 'rpc-client-utils';
import { getVirtualUsersOnPortalRpc } from '../../__generated__/chirp/com/hubspot/multi/account/virtual/user/manager/rpc/VirtualUserChirpFrontendService';
const chirpClient = createRpcClientV2({
  hubHttpClient: apiClient
});
const fetchTeamHierarchy = () => apiClient.get('app-users/v1/teams/hierarchy');
const fetchTeams = () => apiClient.get('app-users/v1/teams');
const fetchUsersForTeams = () => apiClient.get('users/v2/app/hub-users', {
  query: {
    active: true,
    visible: true
  }
}).then(async users => {
  let virtualUserIds = [];
  try {
    const virtualUsers = await chirpClient.call(getVirtualUsersOnPortalRpc, {});
    virtualUserIds = virtualUsers.userIds;
  } catch (error) {
    console.error('Error fetching virtual users', error);
  }
  if (virtualUserIds.length > 0) {
    users = users.filter(user => !virtualUserIds.includes(user.id));
  }
  return users.map(user => {
    const {
      email,
      firstName,
      lastName
    } = user;
    const updatedUser = Object.assign({}, user, {
      fullName: formatName({
        firstName,
        lastName,
        email
      })
    });
    return updatedUser;
  });
});
export const fetchUsersAndTeams = scopes => Promise.all([hasTeamHierarchies(scopes) ? fetchTeamHierarchy() : fetchTeams(), fetchUsersForTeams()]);